import React from 'react';

import LinkShowcase from './LinkShowcase';
import { linksSet } from './constants';

const Links = () => (
  <section>
    <article>
      <ul className="showcase-list">
        {
          linksSet.map((group, i) => (
            <li key={`link-showcase-${i}`}>
              <LinkShowcase {...group} />
            </li>
          ))
        }
      </ul>
    </article>
  </section>
);

export default Links;



// WEBPACK FOOTER //
// ./src/containers/elements/Links/Links.js